import { FakeTopMenu } from "./FakeTopMenu";

export default FakeTopMenu;
